import { SelectForm } from "../../../../components/Input";
import {
  Field,
  FieldHelper,
  FieldLabel,
  LabelRow,
  ToneSegments,
} from "../../../../components/FormPanel";
import {
  SETTLEMENT_ACCOUNT_LABEL,
  SETTLEMENT_HELPER,
  SETTLEMENT_LABEL,
  SETTLEMENT_LOCKED_NOTE,
  SETTLEMENT_SEGMENTS,
  settlementAccountRule,
  settlementSummaryOf,
} from "./settlement";
import { ReadOnlyValue } from "./styles";
import { CashSettlementFieldProps } from "./types";

export const CashSettlementField = ({
  settlement,
  control,
  isSubmitting,
}: CashSettlementFieldProps) => {
  if (!settlement.isShown) {
    return null;
  }

  if (!settlement.isEditable) {
    return (
      <Field>
        <LabelRow>
          <FieldLabel>{SETTLEMENT_LABEL}</FieldLabel>
        </LabelRow>
        <ReadOnlyValue>{settlementSummaryOf(settlement)}</ReadOnlyValue>
        <FieldHelper>{SETTLEMENT_LOCKED_NOTE}</FieldHelper>
      </Field>
    );
  }

  const isLinked = settlement.value === "LINKED_ACCOUNT";

  return (
    <>
      <Field>
        <LabelRow>
          <FieldLabel>{SETTLEMENT_LABEL}</FieldLabel>
        </LabelRow>
        <ToneSegments
          groupLabel={SETTLEMENT_LABEL}
          options={SETTLEMENT_SEGMENTS}
          selectedValue={settlement.value}
          disabled={isSubmitting}
          onChange={(segment) => settlement.onChange(segment.value)}
        />
        <FieldHelper>{SETTLEMENT_HELPER}</FieldHelper>
      </Field>

      {isLinked && (
        <Field>
          <LabelRow>
            <FieldLabel htmlFor="investment-settlement-account">
              {SETTLEMENT_ACCOUNT_LABEL}
            </FieldLabel>
          </LabelRow>
          <SelectForm
            id="investment-settlement-account"
            name="settlementAccount"
            control={control}
            rules={settlementAccountRule(true)}
            defaultValue={null}
            options={settlement.accountOptions}
            disabled={isSubmitting}
          />
        </Field>
      )}
    </>
  );
};
